import ApiService from "../../../common/api.service";
import { router } from "../../../router";

export async function GetOrders({ commit }, option) {
  /**
   * option belum di pakai
   */
  try {
    ApiService.init("heroku");
    commit("GET_ORDERS_REQUEST");
    ApiService.setHeader();
    // const _total = await ApiService.query("/ordermanagement");
    const _response = await ApiService.query("/v1/order/list", option);
    commit("GET_ORDERS_SUCCESS", _response);
  } catch (error) {
    commit("GET_ORDERS_ERROR", { result: error.message });
  }
}

export async function CreateOrder({ commit }, form) {
  try {
    ApiService.init();
    commit("CREATE_ORDER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/ordermanagement", form);
    commit("CREATE_ORDER_SUCCESS", { results: _response });
    router.push("/order");
  } catch (error) {
    commit("CREATE_ORDER_ERROR", { result: error.message });
  }
}

export async function GetOrder({ commit }, params) {
  try {
    ApiService.init("heroku");
    commit("GET_ORDER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get(
      `/v1/order/detail/${params.oracleCustomerId}/${params.orderId}`, `?page=${params.page}&limit=${params.pageSize}`
    );
    commit("GET_ORDER_SUCCESS", _response);
  } catch (error) {
    commit("GET_ORDER_ERROR", { result: error.message });
  }
}

export async function UpdateOrder({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_ORDER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/payment/submit-approval", form);
    commit("EDIT_ORDER_SUCCESS", _response);
    router.go(-1);
  } catch (error) {
    commit("EDIT_ORDER_ERROR", { result: error.message });
  }
}

export async function DeleteOrder({ commit }, id) {
  try {
    ApiService.init();
    commit("DELETE_ORDER_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/ordermanagement/" + id);
    commit("DELETE_ORDER_SUCCESS", { id: id });
  } catch (error) {
    commit("DELETE_ORDER_ERROR", { result: error.message });
  }
}

export async function GetQrCode({ commit }, params) {
  try {
    ApiService.init("heroku");
    commit("GET_QRCODE_REQUEST");
    ApiService.setHeader();
    let _response
    if (params.type === 'TOP') {
      _response = await ApiService.get(
        `/v1/qr/validation-collect-payment/sales/order/${params.orderId}`
      );
    } else if (params.type === 'COD') {
      _response = await ApiService.get(
        `/v1/qr/validation-collect-payment/order/${params.orderId}`
      );
    }
    commit("GET_QRCODE_SUCCESS", _response);
  } catch (error) {
    commit("GET_QRCODE_ERROR", { result: error.message });
  }
}
